import { Link } from "react-router-dom";
import { Plane, ArrowRight } from "lucide-react";
import SectionReveal from "@/components/SectionReveal";

const GlobalFlightsHighlight = () => {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="global-flights" className="relative bg-[#0E2A5C] text-white overflow-hidden" data-testid="global-flights-highlight">
      <div className="absolute inset-0 opacity-15 bg-[radial-gradient(circle_at_80%_20%,#D4AF37_0%,transparent_55%)] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 relative">
        <SectionReveal>
          <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-center">
            <div className="md:col-span-8">
              <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-[#D4AF37] font-semibold mb-5 flex items-center gap-2">
                <Plane size={14} /> Global Flights
              </p>
              <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl leading-[1.08] tracking-tight">
                The World,<br />One Search Away.
              </h2>
              <p className="mt-6 text-lg md:text-xl text-white/80 max-w-2xl leading-relaxed">
                China is our specialty. The world is within reach. Search worldwide
                flight options across full-service and low-cost carriers — for
                business, leisure and journeys to China.
              </p>
            </div>
            <div className="md:col-span-4 flex flex-col gap-4">
              <Link
                to="/flights"
                data-testid="home-search-global-flights"
                className="inline-flex items-center justify-center gap-2.5 bg-[#C62828] hover:bg-[#B71C1C] text-white px-8 py-4 text-sm uppercase tracking-[0.2em] font-semibold transition-colors"
              >
                <Plane size={15} /> Search Global Flights <ArrowRight size={14} />
              </Link>
              <button
                type="button"
                onClick={() => scrollTo("destinations")}
                data-testid="home-explore-china"
                className="inline-flex items-center justify-center gap-2.5 border border-white/40 hover:border-[#D4AF37] hover:text-[#D4AF37] text-white px-8 py-4 text-sm uppercase tracking-[0.2em] font-semibold transition-colors"
              >
                Explore China <ArrowRight size={14} />
              </button>
            </div>
          </div>
        </SectionReveal>
      </div>
    </section>
  );
};

export default GlobalFlightsHighlight;
